<hr>
<h2>Edit Stock</h2><button class="cancel btn btn-warning" (click)="goBack()">Cancel</button>
<hr>
<div >
    <form [formGroup]="myForm" (ngSubmit)="updateStock()" novalidate>
        <div class="form-group" >
                <input type="hidden" class="form-control" id="id" formControlName="id" required />
        </div>
         <div class="form-group" >
            @if (myForm.get('productcode')?.invalid) 
            {
                @if (productcode?.errors?.['required']) {
                        <div class="help-block">
                            Product Code is required.
                        </div>
                }
                @if (productcode?.errors?.['maxlength']) 
                {
                    <div class="help-block">
                            productcode has too many characters.
                    </div>
                }
            }            
            <label for="productcode">Product Code</label>
            <select id="productcode" formControlName="productcode" required >
                @for (product of products; track product.productcode) {
                    <option [ngValue]="product.productcode">{{product.description}}</option>
                }
            </select>
        </div>
        <div class="form-group" >
            @if (myForm.get('warehousecode')?.invalid) 
            {
               @if (warehousecode?.errors?.['required']) {
                        <div class="help-block">
                            Warehouse Code is required.
                        </div>
                }
                @if (warehousecode?.errors?.['maxlength']) 
                {
                    <div class="help-block">
                            warehousecode has too many characters.
                    </div>
                }
            }            
            <label for="warehousecode">Warehouse Code</label>
            <select id="warehousecode" formControlName="warehousecode" required >
                @for (warehousecode of warehousecodes; track warehousecode.warehousecode) {
                    <option [ngValue]="warehousecode.warehousecode">{{warehousecode.description}}</option>
                }
                 </select>        
        </div>
        <div class="form-group" >
                <label for="stockdate">Stock Date</label>
                    @if (myForm.get('stockdate')?.invalid) 
                    {
                        @if (stockdate?.errors?.['pattern']) 
                        {
                            <div class="help-block">
                                Stock Date must use this pattern: MM/DD/YYYY.
                            </div>
                        }
                        @if (stockdate?.errors?.['maxlength']) 
                        {
                            <div class="help-block">
                                stockdate has too many characters.
                            </div>
                        }
                    }
 
                <input type="date" class="form-control" id="stockdate" formControlName="stockdate" required />
        </div>
        <div class="form-group" >
            <label for="volume">volume</label>
                @if (myForm.get('volume')?.invalid) 
                    {
                        @if (volume?.errors?.['pattern']) 
                        {
                            <div class="help-block">
                               Volume must be a number.
                            </div>
                        }
                        @if (volume?.errors?.['required']) 
                        {
                            <div class="help-block">
                                Volume is required.
                            </div>
                        }
                    }
            <input type="text" class="form-control" id="volume" formControlName="volume" required />           
        </div>
        <div class="form-group">
            @if (myForm.get('volumeid')?.invalid) 
            {
                @if (volume?.errors?.['required']) 
                {
                            <div class="help-block">
                                Volume ID is required.
                            </div>
                }
            }
            <label for="volumeid">Volume ID (B,L,P or C)</label>
            <select id="volumeid" formControlName="volumeid" required>
                <option value="B">Base Unit of Measure</option>
                <option value="L">Litre</option>
                <option value="P">Pack</option>
                <option value="C">Case</option>
            </select>
        </div>
        <div class="form-group" >
            <label for="value">Value (volume * COST)</label>
           @if (myForm.get('value')?.invalid) 
            {
                @if (value?.errors?.['required']) 
                {
                            <div class="help-block">
                                Value is required.
                            </div>
                }
               @if (value?.errors?.['pattern']) {
                        <div class="help-block">
                            Value must be a number.
                        </div>
                }
            }
            <input type="text" class="form-control" id="value" formControlName="value" required />
        </div>
        <div class="form-group" >
            <label for="allocatedvolume">Allocated Volume (optional)</label>
            @if (myForm.get('allocatedvolume')?.invalid) 
            {

               @if (allocatedvolume?.errors?.['pattern']) {
                        <div class="help-block">
                            Allocated Volume must be a number.
                        </div>
                }
            }
            <input type="text" class="form-control" id="allocatedvolume" formControlName="allocatedvolume" />
            
        </div>
        <div class="form-group" >
            @if (myForm.get('producttype')?.invalid) 
            {
                @if (producttype?.errors?.['required']) 
                {
                            <div class="help-block">
                                Product Type is required.
                            </div>
                }
            }
            <label for="producttype">Product Type</label>
            <select id="producttype" formControlName="producttype" required >
                <option value="I">Inventory</option>
                <option value="N">Non-Inventory</option>
             </select>
                            
        </div>
        <div class="form-group">
                <label for="uploaded">Date Uploaded: {{uploaded?.value == '0000-00-00' ? 'Pending' :uploaded?.value | date:'MM/dd/yyyy'}}</label>
        </div>
  <div class="form-group">
            <button type="submit" [disabled]="myForm.invalid" class="btn btn-primary">Update</button>
        </div>
    </form>
    
</div>